import { Article } from 't2-graphql-types';
import { TArticleInteractionData } from './ArticleInteractions/types';
import ArticleHeaderInfoToolbar from './ArticleHeaderInfoToolbar';
import ArticleHeaderInfoDetails from './ArticleHeaderInfoDetails';

type TArticleHeaderInfoProps = Pick<
  Required<Article>,
  'readTime' | 'author' | 'publishedAt' | 'totalTimePointsAccumulated' | 'id' | 'commentsCount' | 'slug'
> & {
  usersWhoReadArticle?: TArticleInteractionData[];
};

export const generateTimePointText = (readTime: number) => (readTime ? `${readTime} min read` : '');

const ArticleHeaderInfo: React.FC<TArticleHeaderInfoProps> = ({
  author,
  publishedAt,
  readTime,
  totalTimePointsAccumulated,
  id,
  usersWhoReadArticle = [],
  commentsCount,
  slug,
}) => (
  <>
    <ArticleHeaderInfoDetails author={author} publishedAt={publishedAt} readTime={readTime} />
    <ArticleHeaderInfoToolbar
      id={id}
      totalTimePointsAccumulated={totalTimePointsAccumulated}
      usersWhoReadArticle={usersWhoReadArticle}
      commentsCount={commentsCount as number}
      slug={slug!}
    />
  </>
);

export default ArticleHeaderInfo;
